console.log('SHIRT PERSONALIZATION SCRIPT LOADED');

(function () {
  function updateExtras(box) {
    console.log('UPDATE EXTRAS START', box);
    if (!box) return;

    var player = box.querySelector('.personalization-select');
    var name = box.querySelector('.personalization-name');
    var number = box.querySelector('.personalization-number');
    var badgeBox = box.querySelector('.badge-personalization');

    var hasPersonalization =
      (player && player.value) ||
      (name && name.value.trim()) ||
      (number && number.value);

    var hasBadge =
      badgeBox &&
      (
        badgeBox.dataset.selectedBadge ||
        badgeBox.querySelector('.badge-option.active')
      );

    var wanted = 'Sem Extras';

    if (hasPersonalization && hasBadge) {
      wanted = 'Personalização + Badge';
    } else if (hasPersonalization) {
      wanted = 'Personalização';
    } else if (hasBadge) {
      wanted = 'Badge';
    }

    console.log('WANTED:', wanted);


    var root =
      box.closest('product-component') ||
      box.closest('#quick-add-modal-content') ||
      document;

    var extrasInput = Array.from(
  root.querySelectorAll('input[data-option-name="Extras"]')
).find(function (input) {
  return input.value === wanted;
});

if (extrasInput) {
  extrasInput.checked = true;

  extrasInput.dispatchEvent(
    new Event('input', { bubbles: true })
  );

  extrasInput.dispatchEvent(
    new Event('change', { bubbles: true })
  );

  extrasInput.closest('variant-picker')?.dispatchEvent(
    new Event('change', { bubbles: true })
  );

  return;
}

var extrasSelect = root.querySelector(
  'select option[data-option-name="Extras"][value="' + wanted + '"]'
)?.closest('select');

if (extrasSelect) {
  extrasSelect.value = wanted;

  extrasSelect.dispatchEvent(
    new Event('input', { bubbles: true })
  );

  extrasSelect.dispatchEvent(
    new Event('change', { bubbles: true })
  );
}
}

function syncCartProperties(box) {
  if (!box) return;

  var root =
    box.closest('product-component') ||
    box.closest('#quick-add-modal-content') ||
    document;

  var form = root.querySelector('form[action*="/cart/add"]');
  if (!form) return;

  var player = box.querySelector('.personalization-select');
  var name = box.querySelector('.personalization-name');
  var number = box.querySelector('.personalization-number');
  var badgeBox = box.querySelector('.badge-personalization');

  var playerValue = player ? player.value.trim() : '';
  var nameValue = name ? name.value.trim() : '';
  var numberValue = number ? number.value.trim() : '';

  var badgeValue = '';
  if (badgeBox) {
    badgeValue =
      badgeBox.dataset.selectedBadge ||
      (badgeBox.querySelector('.badge-option.active')
        ? badgeBox.querySelector('.badge-option.active').dataset.badge
        : '');
  }

  function setProperty(propertyName, value) {
    var input = form.querySelector(
      'input[data-personalization-property="' + propertyName + '"]'
    );

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.dataset.personalizationProperty = propertyName;
      input.name = 'properties[' + propertyName + ']';
      form.appendChild(input);
    }

    input.value = value || '';
  }

  var playerName = '';
  var playerNumber = '';

  if (playerValue) {
    var match = playerValue.match(/^(.*?)\s*(?:-|·)\s*(\d+)\s*$/);

    if (match) {
      playerName = match[1].trim();
      playerNumber = match[2].trim();
    } else {
      playerName = playerValue;
    }
  }

  setProperty('Jogador', playerName);
  setProperty('Nome personalizado', nameValue);
  setProperty(
    'Número personalizado',
    playerName ? playerNumber : numberValue
  );
  setProperty('Badge', badgeValue);
}

  function bindPersonalization(box) {
    if (!box || box.dataset.extrasSyncBound === 'true') return;

    box.dataset.extrasSyncBound = 'true';

    box.addEventListener('change', function () {
      updateExtras(box);
      syncCartProperties(box);
    });

    box.addEventListener('input', function () {
      updateExtras(box);
      syncCartProperties(box);
    });

    box.addEventListener('click', function () {
      setTimeout(function () {
        updateExtras(box);
        syncCartProperties(box);
      }, 0);
    });
  }

  document.querySelectorAll('.shirt-personalization').forEach(
    bindPersonalization
  );

  new MutationObserver(function () {
    document.querySelectorAll('.shirt-personalization').forEach(
      bindPersonalization
    );
  }).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();